// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.APIKeyInput-module__APIInputContainer--__lm4{display:flex;align-items:center;position:relative}.APIKeyInput-module__APIInputContainer--__lm4 p.ds-input-title{margin-bottom:12px}.APIKeyInput-module__APIInputContainer--__lm4 svg{color:#8c95a8}.APIKeyInput-module__APIInputContainer--__lm4 .ds-input-wrapper{min-width:230px}.APIKeyInput-module__APIInputContainer--__lm4 .APIKeyInput-module__resetIconContainer--WYiCD{display:flex;align-items:center;justify-content:center;cursor:pointer}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"APIInputContainer": `APIKeyInput-module__APIInputContainer--__lm4`,
	"resetIconContainer": `APIKeyInput-module__resetIconContainer--WYiCD`
};
module.exports = ___CSS_LOADER_EXPORT___;
